<template>
    <base-power-up :power-up="powerUp" :disabled="disabled">
        <div class="btn-icon btn-icon--percent">
            <svg class="icon">
                <use xlink:href="/img/icon-sprite.svg#percent"></use>
            </svg>
        </div>
        {{ powerUp.name }}
    </base-power-up>
</template>

<script>
import BasePowerUp from "./BasePowerUp";

export default {
    components: {BasePowerUp},
    props: {
        powerUp: Object,

        answered: {
            default: false
        },

        opponentAnswered: {
            default: false
        }
    },

    computed: {
        disabled() {
            if (this.answered) {
                return true
            }

            return false
        }
    }
}
</script>
